"use client";

// packages/eden-text/src/components/Text1.jsx
import styled from "styled-components";
import shared from './shared.js';
import { jsx } from "react/jsx-runtime";
var Container1 = styled.div`
  font: var(--unity-text1-body);
  ${shared};
  ${({ $emphasized }) => $emphasized ? "font: var(--unity-text1-body-emphasized)" : ""};
`;
var Text1 = ({ children, renderAs = "div", emphasized, ...props }) => /* @__PURE__ */ jsx(Container1, { as: renderAs, $emphasized: emphasized, ...props, children });
Text1.displayName = "Text1";
var Text1_default = Text1;
export {
  Text1_default as default
};
